var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.3999 13.6C2.3999 13.3878 2.48419 13.1843 2.63422 13.0343C2.78425 12.8843 2.98773 12.8 3.1999 12.8H12.7999C13.0121 12.8 13.2156 12.8843 13.3656 13.0343C13.5156 13.1843 13.5999 13.3878 13.5999 13.6C13.5999 13.8122 13.5156 14.0156 13.3656 14.1657C13.2156 14.3157 13.0121 14.4 12.7999 14.4H3.1999C2.98773 14.4 2.78425 14.3157 2.63422 14.1657C2.48419 14.0156 2.3999 13.8122 2.3999 13.6ZM5.0343 5.36559C4.88433 5.21557 4.80007 5.01212 4.80007 4.79999C4.80007 4.58786 4.88433 4.38441 5.0343 4.23439L7.4343 1.83439C7.58432 1.68441 7.78777 1.60016 7.9999 1.60016C8.21203 1.60016 8.41548 1.68441 8.5655 1.83439L10.9655 4.23439C11.1112 4.38527 11.1919 4.58735 11.19 4.79711C11.1882 5.00687 11.1041 5.20752 10.9558 5.35584C10.8074 5.50417 10.6068 5.5883 10.397 5.59013C10.1873 5.59195 9.98518 5.51131 9.8343 5.36559L8.7999 4.33119V10.4C8.7999 10.6122 8.71562 10.8156 8.56559 10.9657C8.41556 11.1157 8.21208 11.2 7.9999 11.2C7.78773 11.2 7.58425 11.1157 7.43422 10.9657C7.28419 10.8156 7.1999 10.6122 7.1999 10.4V4.33119L6.1655 5.36559C6.01548 5.51556 5.81203 5.59982 5.5999 5.59982C5.38777 5.59982 5.18432 5.51556 5.0343 5.36559Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/Upload.492b066f764730218884c9dc9eb770e8.svg";
export { ForwardRef as ReactComponent };